export function useMobileKeyboard() {
    const toggleModalKeyboardClass = () => {
        document.querySelector(".modal-box")?.classList.toggle("keyboard");
    };

    return { toggleModalKeyboardClass };
}
